// Singular list of facility/hazard vector types supported by API
export const FACILITY_VECTOR_ELEMENTS = [
  "Tree",
  "Rock",
  "Bridge",
  "Cliff",
  "Forest",
  "Sand",
  "Water",
  "Vegetation",
  "Ocean",
  "Lava",
  "Fixtures",
  "NativeArea",
  "Residence",
  "Creek",
  "Condo",
  "Hotel",
  "Business",
  "Pool",
  "ParkingLot",
  "Street",
  "Fence",
  "Patio",
  "Waterfall",
  "Flowers",
];

export const normalizeElementForApi = (el) => (el === "Nativearea" ? "NativeArea" : el);

export const isFacilityVectorElement = (el) =>
  FACILITY_VECTOR_ELEMENTS.includes(normalizeElementForApi(el));

// Element names accepted by CourseGPSVectorMapRemove API for bulk deletion.
// Elements not in this set must be deleted individually (active: 0 per shape).
export const BULK_DELETE_API_SUPPORTED = new Set([
  "Water", "Tree", "Ocean", "Sand", "Rock", "Lava", "Cliff",
  "NativeArea", "Fixtures", "Vegetation", "Creek", "Forest", "Bridge",
  "Residence", "Waterfall", "Flowers",
]);

